import { types, Instance } from 'mobx-state-tree';

export const CustomerBillingAddressModel = types.model({
  id: types.number,
  firstName: types.string,
  lastName: types.string,
  address1: types.string,
  address2: types.string,
  city: types.string,
  state: types.string,
  postalCode: types.string,
  country: types.string,
  phoneNumber: types.string,
  companyName: types.maybeNull(types.string),
  preferred: types.maybeNull(types.boolean),
});

export type ICustomerBillingAddressModel = Instance<
  typeof CustomerBillingAddressModel
>;

export const CustomerShippingAddressModel = types.compose(
  CustomerBillingAddressModel,
  types.model({
    residential: types.optional(types.boolean, false, [null, false]),
  })
);

export type ICustomerShippingAddressModel = Instance<
  typeof CustomerShippingAddressModel
>;

export const CustomerPaymentProfileCardModel = types.model({
  pCIaaSId: types.string,
  cardNumber: types.string,
  last4: types.string,
  cardBrand: types.optional(types.maybeNull(types.string), null),
  cardType: types.union(types.number, types.string),
  cardTypeName: types.string,
  holdersName: types.string,
  expMonth: types.string,
  expYear: types.string,
  cardToken: types.optional(types.maybeNull(types.string), null),
  cardTokenProvider: types.optional(types.maybeNull(types.string), null),
  paymentMethodFingerprint: types.optional(types.maybeNull(types.string), null),
  id: types.maybeNull(types.number),
  issueNumber: types.string,
  issueMonth: types.string,
  issueYear: types.string,
  browserInfo: types.maybeNull(types.string),
  challengeResponse: types.maybeNull(types.string),
  transactionToken: types.maybeNull(types.string),
});

export type ICustomerPaymentProfileCardModel = Instance<
  typeof CustomerPaymentProfileCardModel
>;

export const CustomerPaymentProfileModel = types.model({
  id: types.number,
  method: types.string,
  card: CustomerPaymentProfileCardModel,
  preferred: types.maybeNull(types.boolean),
});

export type ICustomerPaymentProfileModel = Instance<
  typeof CustomerPaymentProfileModel
>;
